import Tabs, { Tab, TabList } from '@atlaskit/tabs';
import React from 'react';
import { onTabSelected, useAnalytics } from '../../../common/analytics';
import { withABTestContext } from '../../ab-test-context';
import { DisableXPSAB } from '../../ab-test-context/experiment-hoc';
import { withDialogExpansionContext } from '../../dialog-expansion-context/dialog-expansion-context';
import { withProductContext } from '../product-router';
import { TabControlsWrapper } from './tab-controls.styled';

/**
 * Empty interface required to get withProductContext HOC to type properly.
 */

var CustomTab = function CustomTab(_ref) {
  var index = _ref.index,
    title = _ref.title,
    tabRenderer = _ref.tabRenderer;
  return /*#__PURE__*/React.createElement(Tab, {
    key: index,
    testId: "search-dialog-product-tab-".concat(index)
  }, tabRenderer ? tabRenderer({
    title: title
  }) : title);
};
export var ProductTabsInner = function ProductTabsInner(props) {
  var _getActiveProduct;
  var products = props.products,
    showProduct = props.showProduct,
    getActiveProduct = props.getActiveProduct,
    isExpanded = props.isExpanded,
    abTest = props.abTest;
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  var onTabClicked = function onTabClicked(index) {
    var id = products[index].id;
    showProduct(products[index].id);
    fireAnalyticsEvent(onTabSelected({
      tabName: id
    }));
  };
  var activeProductId = (_getActiveProduct = getActiveProduct()) === null || _getActiveProduct === void 0 ? void 0 : _getActiveProduct.id;
  var activeProductIndex = products.findIndex(function (product) {
    return product.id === activeProductId;
  });
  var primaryProduct = products.find(function (product) {
    return product.order === 0;
  });
  if (activeProductIndex === -1 && isExpanded && primaryProduct && abTest) {
    showProduct(primaryProduct.id);
    return null;
  }
  if (!isExpanded || products.length === 1 || !abTest || !primaryProduct) {
    return null;
  }
  // Tabs has unwanted flex-basis: 100% set, div wrapper gets around this

  return /*#__PURE__*/React.createElement(DisableXPSAB, null, /*#__PURE__*/React.createElement(TabControlsWrapper, null, /*#__PURE__*/React.createElement(Tabs, {
    selected: activeProductIndex,
    onChange: onTabClicked,
    id: "tab-controls",
    shouldUnmountTabPanelOnChange: true
  }, /*#__PURE__*/React.createElement(TabList, null, products.map(function (product, index) {
    return /*#__PURE__*/React.createElement(CustomTab, {
      key: product.id,
      index: index,
      title: product.title,
      tabRenderer: product.tabRenderer
    });
  })))));
};
export var ProductTabs = withABTestContext(withProductContext(withDialogExpansionContext(ProductTabsInner)));